import { useTranslation } from 'react-i18next';

export default function SessionRecoveryModal({ 
  sessionData, 
  onResume, 
  onStartFresh 
}) {
  const { t, i18n } = useTranslation();
  
  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  
  const getDrillName = () => {
    if (!sessionData.currentDrill) return t('recovery.none');
    // Handle both old format (name) and new format (nameEn/nameHe)
    return sessionData.currentDrill[`name${i18n.language === 'he' ? 'He' : 'En'}`] 
      || sessionData.currentDrill.name 
      || t('recovery.none');
  };
  
  return (
    <div className="fixed inset-0 bg-white bg-opacity-95 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-5 max-w-md w-full mx-4 shadow-xl border-2 border-blue-500 max-h-[85vh] overflow-y-auto">
        <div className="text-center mb-4">
          <div className="text-6xl mb-3" style={{ fontSize: '80px' }}>🔄</div>
          <h2 className="text-2xl font-bold mb-3">
            {t('recovery.title')}
          </h2>
          <p className="text-gray-600 text-sm leading-[1.4] max-w-full mb-4 overflow-hidden" style={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>
            {t('recovery.description')}
          </p>
        </div>
        
        <div className="bg-gray-50 rounded-lg p-4 mb-5" style={{ maxHeight: '120px' }}>
          <h3 className="font-bold mb-2 text-gray-700 text-base">
            {t('recovery.session_summary')}
          </h3>
          
          <div>
            <div className="flex justify-between text-sm mb-3">
              <span className="text-gray-600">{t('training.total_time')}:</span>
              <span className="font-bold">{formatTime(sessionData.sessionElapsedSeconds || 0)}</span>
            </div>
            
            <div className="flex justify-between text-sm mb-3">
              <span className="text-gray-600">{t('recovery.current_drill')}:</span>
              <span className="font-bold truncate">{getDrillName()}</span>
            </div>
            
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">{t('training.completed_drills')}:</span>
              <span className="font-bold">{sessionData.completedDrills?.length || 0}</span>
            </div>
          </div>
        </div>
        
        <div className="space-y-3">
          <button
            onClick={onResume}
            className="w-full bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 text-base h-[52px] flex items-center justify-center transition-all"
          >
            {t('recovery.resume')}
          </button>
          
          <button
            onClick={onStartFresh}
            className="w-full bg-gray-200 text-gray-700 rounded-lg font-bold hover:bg-gray-300 text-base h-[48px] flex items-center justify-center transition-all"
          >
            {t('recovery.start_fresh')}
          </button>
        </div>
      </div>
    </div>
  );
}
